import { NgModule } from '@angular/core';
import { AxisComponent } from './axis/axis';

@NgModule({
  declarations: [AxisComponent],
  imports: [],
  exports: [AxisComponent]
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts